import { useCurrentUser } from 'hooks/useCurrentUser';
import { useEffect } from 'react';

export function useHubSpotUser() {
  const { data } = useCurrentUser();

  useEffect(() => {
    if (!data?.user) {
      return;
    }

    window._hsq = window._hsq || [];
    window._hsq.push(['identify', { email: data.user.email }]);
  }, [data?.user]);
}
